import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cotwo',
  templateUrl: './cotwo.component.html',
  styleUrls: ['./cotwo.component.css']
})
export class CotwoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
